
































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  filters: {
    padZero(value: number) {
      return ('0' + value).slice(-2);
    },
    formatLift(value: any) {
      const seconds: number = value % 60;
      const minutes: number = Math.trunc((value / 60)) % 60;
      const minutesPadded = ('0' + minutes).slice(-2);
      const secondsPadded = ('0' + seconds).slice(-2);
      return(`${minutesPadded}:${secondsPadded}`);
    },
    formatTotal(value: any) {
      const seconds: number = value % 60;
      const minutes: number = Math.trunc((value / 60)) % 60;
      const hours: number = Math.trunc((value / 60 / 60)) % 60;
      const hoursPadded = ('0' + hours).slice(-2);
      const minutesPadded = ('0' + minutes).slice(-2);
      const secondsPadded = ('0' + seconds).slice(-2);
      return(`${hoursPadded}:${minutesPadded}:${secondsPadded}`);
    },
  },
})
export default class Control extends Vue {
  @Prop() private timerDisplay!: string;
  @Prop() private deadTimeAry!: any;
  @Prop() private benchTimeAry!: any;
  @Prop() private cleanTimeAry!: any;
  @Prop() private totalTimeAry!: any;
  @Prop() private repScheme!: number[];
  @Prop() private deadWeight!: number;
  @Prop() private benchWeight!: number;
  @Prop() private cleanWeight!: number;
  @Prop() private weightMeasurementLable!: string;
  @Prop() private bodyWeight!: string;
  @Prop() private resultScale!: string;

  private resetApp() {
    this.$emit('reset-app');
  }
}
